import { PureComponent } from 'react';

const HasPasswordToggle = Component =>
  class HasPasswordToggle extends PureComponent {
    state = { type: 'password' };

    handleVisibilityToggle = () => {
      this.setState(prevState => ({
        type: prevState.type === 'password' ? 'text' : 'password',
      }));
      this.props.innerRef.current.focus();
    };

    render() {
      const {
        wrapperClassName = 'form__input-wrap',
        buttonClassName,
        value,
        tabIndex,
        btnTabIndex,
        ...rest
      } = this.props;

      return (
        <div className={wrapperClassName}>
          <Component
            type={this.state.type}
            autoComplete="nope"
            value={value}
            {...rest}
            tabIndex={tabIndex}
          />
          {value && (
            <button
              type="button"
              className={buttonClassName}
              tabIndex={btnTabIndex}
              onClick={this.handleVisibilityToggle}
            >
              {this.state.type === 'password' ? 'SHOW' : 'HIDE'}
            </button>
          )}
        </div>
      );
    }
  };

export default HasPasswordToggle;
